export const CUSTOMER_PRICES_SHOULD_FETCH_PRICES =
  'CUSTOMER_PRICES_SHOULD_FETCH_PRICES';
export const CUSTOMER_PRICES_RECEIVE_PRICES = 'CUSTOMER_PRICES_RECEIVE_PRICES';
export const CUSTOMER_PRICES_ARTICLE_NUMBER_TO_FETCH_PRICES =
  'CUSTOMER_PRICES_ARTICLE_NUMBER_TO_FETCH_PRICES';
export const CUSTOMER_PRICE_LOAD_ERROR = 'CUSTOMER_PRICE_LOAD_ERROR';

import { post } from '../Services/http';
import { catchError } from './Error.action';

export const setArticleNumberToFetchPrices = (data) => ({
  type: CUSTOMER_PRICES_ARTICLE_NUMBER_TO_FETCH_PRICES,
  payload: {
    articleNumber: data,
  },
});

export const loadError = (error) => ({
  type: CUSTOMER_PRICE_LOAD_ERROR,
  payload: {
    error,
  },
});

export const receivePrices = (data) => ({
  type: CUSTOMER_PRICES_RECEIVE_PRICES,
  payload: {
    priceList: data,
  },
});

export const getPrices = (forceReRun) => (dispatch, getState) => {
  const { articleNumberToFetchPrices, priceList } = getState().customerPrices;

  //Filter out the article numbers that we have already fetched
  const list = forceReRun
    ? articleNumberToFetchPrices
    : articleNumberToFetchPrices.filter(
        (x) => !Object.values(priceList).find((y) => y.variantSystemId === x)
      );

  if (list.length > 0) {
    return post('/api/customerprice', list)
      .then((response) => response.json())
      .then((data) => {
          dispatch(receivePrices(data));
      })
      .catch((ex) => {
        dispatch(catchError(ex, (error) => loadError(error)));
        throw ex;
      });
  }
  return false;
};
